import React, {useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
//import "bootstrap/dist/css/bootstrap.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";
import logo from "./../../Public/img/logo-black.png";
import { ToastContainer } from 'react-toastify';
import {successMesg, errorMesg} from "./../Toaster";
import {forgotPasswordAPI} from "./../../API/AuthenticationAPI";

const ForgotPassword = () =>{

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [btnloading, setBtnLoading] = useState(false);

    useEffect(()=>{
        console.log('I am in forgot password');

    },[]);

    const handleEmail = (event) =>{
        setEmail(event.target.value);
    }

    const resetForm = () =>{
        setEmail("");
    }

    const handleForgotPassword = (e) =>{
        e.preventDefault();

        if(email === "")
        {
            //alert('c');
            errorMesg("Please enter your email");
        }
        else
        {
            const params = {
                            email: email,
                        };

            forgotPasswordAPI(params, setBtnLoading, navigate, resetForm);
        }
    }
    return(
        <div className="account-page">
            <div className="main-wrapper">
                <div className="account-content">
                    <div className="w-100 vh-100 overflow-hidden auth-wrapper basic-auth">
                        <div className="auth-inner">
                            <div className="card__wrapper overflow-auto">
                                <form action="#" className="flex-fill">
                                    <div className="mx-auto mw-450">
                                        <div className="text-center mb-4 img-logo">
                                            <img src={logo} className="img-fluid" alt="Logo" />
                                        </div>
                                        <div className="mb-4 text-center">
                                            <h4 className="mb-2 fs-20">Forgot Password?</h4>                                            
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Email </label>
                                            <div className="position-relative">
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-mail"></i>
                                                </span>
                                                <input type="text" name="email" id="email" value={email} className="form-control" onChange={handleEmail} />
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <button type="button" className="btn btn-primary w-100" onClick={handleForgotPassword}>
                                                {btnloading ?
                                                    <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                :
                                                    <p>Submit</p>
                                                }
                                            </button>
                                        </div>
                                        <div className="mb-3 text-center">
                                            <h6>Return to <Link to="/sign-in"  className="text-purple link-hover">Login</Link> </h6>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                
                <ToastContainer />
            </div>
        </div>
    )
}

export default ForgotPassword;